module.exports = gsap;


//////////////////
// WEBPACK FOOTER
// external "gsap"
// module id = 6
// module chunks = 0